import { UserManager } from "oidc-client-ts";
import { Service } from "./service";
import { cleanOidcUrl } from "../utils/cleanOidcUrl";

export enum UserEditTypeEnum {
  email = "UPDATE_EMAIL",
  password = "UPDATE_PASSWORD",
  phoneNumber = "mesvaccins-update-mobile-number",
}

export class EditUserService implements Service<{ editType: UserEditTypeEnum }, void> {
  constructor(
    private readonly window: Window,
    private readonly oidcManager: UserManager
  ) {}

  async call({ editType }: { editType: UserEditTypeEnum }) {
    await this.oidcManager.signinRedirect({
      redirect_uri: cleanOidcUrl(this.window.location.href).toString(),
      extraQueryParams: { kc_action: editType },
    });
  }
}
